var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinktree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.474 13.46V20H8.588v-6.54h2.886zM11.464 0v4.884l3.325-3.428 1.924 1.983-3.492 3.333h4.904v2.753h-4.936l3.514 3.429-1.924 1.93-4.768-4.81-4.769 4.81-1.934-1.93L6.81 9.525H1.875V6.772h.042v-.01H6.82L3.33 3.428l1.924-1.983 3.325 3.428V0h2.886z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktree);
export default __webpack_public_path__ + "static/media/Linktree.3a4b455b40b8db8ed565e3e2a6703dd7.svg";
export { ForwardRef as ReactComponent };